import parse, { domToReact } from 'html-react-parser';

import Text from 'shopper/components/Text';

import Image from 'components/Image';

import { toFallbackImageAltText } from 'lib/image';

import HTML_PARSER from 'constants/htmlParser';

const lastCommentsTextOptions = {
  trim: true,

  replace: ({ name, attribs, children }) => {
    if (name === HTML_PARSER.NAME_IMAGE) {
      const { src, alt } = attribs;

      return (
        <Image
          alt={toFallbackImageAltText(alt)}
          className="block size-auto max-w-[208px] xl:max-w-xs"
          height={88}
          src={src}
          width={150}
        />
      );
    }

    if (!attribs || children.length === 0) {
      return null;
    }

    if (name === HTML_PARSER.NAME_PARAGRAPH) {
      return (
        <Text as="span">{domToReact(children, lastCommentsTextOptions)}</Text>
      );
    }

    if (name === HTML_PARSER.NAME_HREF) {
      return (
        <Text as="span" className="inline break-all" bold>
          {domToReact(children, lastCommentsTextOptions)}
        </Text>
      );
    }
  },
};

const toLastCommentText = (lastCommentText) =>
  lastCommentText ? parse(lastCommentText, lastCommentsTextOptions) : null;

export default toLastCommentText;
